import { map, keyBy } from 'lodash'
import {
  GET_DISTRICTS_LOADING,
  GET_DISTRICTS_SUCCESS,
  GET_DISTRICTS_FAILURE,
} from '../actions'

const defaultState = {
  codeList: [],
  byCode: {},
  loading: false,
  error: null,
}

export default (prevState = defaultState, { payload, type, error }) => {
  switch (type) {
    case GET_DISTRICTS_LOADING:
      return {
        ...prevState,
        loading: true,
      }
    case GET_DISTRICTS_FAILURE:
      return {
        ...prevState,
        error,
        loading: false,
      }
    case GET_DISTRICTS_SUCCESS:
      return {
        ...prevState,
        codeList: map(payload, 'automobile'),
        byCode: keyBy(payload, 'automobile'),
        byId: keyBy(payload, 'id'),
        loading: false,
      }
    default:
      return prevState
  }
}



// WEBPACK FOOTER //
// ./src/reducers/districts.js